<footer class="app-footer">
  <div class="footer-inner">

    <div class="footer-brand">
      <app-marca-logo [alto]="26" [anchoMax]="120" [contorno]="false" class="footer-brand__logo" />
      <span class="footer-brand__name">{{ marca.nombre() }}</span>
    </div>

    <!-- Bloque de soporte + contacto -->
    <div class="footer-main">

      <!-- Tarjeta "Solicitar ayuda" -->
      <button type="button" class="footer-help-card" (click)="abrirTicket()">
        <div class="footer-help-card__icon">
          <span class="pi pi-ticket"></span>
        </div>
        <div class="footer-help-card__body">
          <span class="footer-help-card__title">¿Necesitas ayuda?</span>
          <span class="footer-help-card__desc">Crea un ticket y el equipo TI te contactará a la brevedad</span>
        </div>
        <div class="footer-help-card__cta">
          <span class="pi pi-arrow-up-right"></span>
          Solicitar ayuda
        </div>
      </button>

      <!-- Contacto general -->
      <div class="footer-contact-simple">
        <span class="pi pi-headphones footer-contact-simple__icon"></span>
        <div class="footer-contact-simple__body">
          <span class="footer-contact-simple__label">¿Otra consulta?</span>
          <span class="footer-contact-simple__desc">Escríbenos y te responderemos a la brevedad</span>
          <a href="mailto:soporte@grupohexxa.cl" class="footer-contact-simple__email">soporte&#64;grupohexxa.cl</a>
        </div>
      </div>

    </div>

    <div class="footer-copy">
      © {{ year }} Grupo Hexxa. Todos los derechos reservados.
    </div>

  </div>
</footer>
